// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"769aa998","52":"94139ae8","102":"8a364dfa","331":"bea73358","356":"13124d63","357":"2f336281","852":"a0e4daf1","857":"f40db429"}[chunkId] + ".chunk.css";
};